import { Provider } from './provider'

export async function getProvider(name?: string): Promise<Provider> {
  const { ShopifyProvider } = await import('./shopify')
  return new ShopifyProvider()
}
